import React from "react";
import useAttendance from "../../hooks/useAttendance";
import ProFilter from "../common/ProFilter";

const ProAttendanceFilter = ({toggleFilter})=>{

    const { data:{ filter }, actions:{ SetFilter, ResetFilter } } = useAttendance({ refreshTree: false });

    return <ProFilter filter={filter} toggleFilter={toggleFilter} SetFilter={SetFilter} ResetFilter={ResetFilter} showLOS={false}/>
}

export default ProAttendanceFilter;